import { heading, text, button, image, divider, spacer, social, footerBlk, headerBar, columns, hero } from './builders'

const TEMPLATES = [
  {
    id: 'fmcg-product-launch',
    category: 'fmcg',
    name: 'Product Launch',
    description: 'Introduce a new consumer product with a vibrant hero and a Discover CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Shop', 'Recipes', 'About', 'Store Locator'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#e11d48',
        paddingTop: 16,
        paddingBottom: 16
      }),
      hero('NEW: $product_name', 'e11d48', 'ffffff', { paddingTop: '0', paddingBottom: '0' }),
      spacer('24'),
      heading('Say hello to $product_name', {
        fontSize: '28',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '8'
      }),
      text('Hi $first_name, we have been busy in the kitchen and we cannot wait for you to try it. <strong>$product_name</strong> is here — crafted with real ingredients, bold flavor, and none of the stuff you cannot pronounce.', {
        color: '#4b5563',
        fontSize: '16',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingTop: '4',
        paddingBottom: '16'
      }),
      button('Discover $product_name', 'https://shop.example.com/new/product', {
        backgroundColor: '#e11d48',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '32',
        buttonPaddingV: '14'
      }),
      spacer('16'),
      text('Available now at your favorite grocers and online. Be one of the first to taste what everyone will be talking about.', {
        color: '#be123c',
        backgroundColor: '#fff1f2',
        fontSize: '13',
        alignment: 'center',
        lineHeight: '1.6',
        paddingTop: '14',
        paddingBottom: '14',
        paddingLeft: '40',
        paddingRight: '40'
      }),
      spacer('24'),
      divider(),
      social(),
      footerBlk('You are receiving this because you signed up for product news. <a href="{{unsubscribe}}">Unsubscribe</a> anytime. 123 Market Street, Suite 400.', {
        backgroundColor: '#fff1f2',
        color: '#9f1239',
        fontSize: '12'
      })
    ]
  },
  {
    id: 'fmcg-seasonal-offer',
    category: 'fmcg',
    name: 'Seasonal Campaign',
    description: 'Limited-time seasonal promo with an offer code and Shop / Find in store CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Shop', 'Offers', 'Recipes', 'Store Locator'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#f97316',
        paddingTop: 16,
        paddingBottom: 16
      }),
      hero('SUMMER SAVINGS', 'f97316', 'ffffff', { paddingTop: '0', paddingBottom: '0' }),
      spacer('24'),
      heading('Stock up for the season, $first_name', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '8'
      }),
      text('The sunny days are here and so are the deals. For a limited time, enjoy <strong>20% off</strong> your favorite pantry and picnic staples. Fill the cart, fire up the grill, and make this season delicious.', {
        color: '#4b5563',
        fontSize: '16',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingTop: '4',
        paddingBottom: '12'
      }),
      heading('Use code $offer_code at checkout', {
        fontSize: '20',
        fontWeight: '700',
        alignment: 'center',
        color: '#f97316',
        backgroundColor: '#fff7ed',
        paddingTop: '14',
        paddingBottom: '14',
        paddingLeft: '16',
        paddingRight: '16'
      }),
      spacer('16'),
      button('Shop the sale', 'https://shop.example.com/summer', {
        backgroundColor: '#f97316',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '30',
        buttonPaddingV: '14'
      }),
      spacer('8'),
      button('Find in store', 'https://shop.example.com/stores', {
        backgroundColor: '#ffffff',
        textColor: '#f97316',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '30',
        buttonPaddingV: '12'
      }),
      spacer('16'),
      text('Offer valid through the end of the season while supplies last. One code per order. Cannot be combined with other promotions.', {
        color: '#9ca3af',
        fontSize: '12',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '40',
        paddingRight: '40'
      }),
      spacer('20'),
      divider(),
      social(),
      footerBlk('You are subscribed to seasonal offers. <a href="{{unsubscribe}}">Unsubscribe</a>. 123 Market Street, Suite 400.', {
        backgroundColor: '#fff7ed',
        color: '#9a3412',
        fontSize: '12'
      })
    ]
  },
  {
    id: 'fmcg-recipe-tips',
    category: 'fmcg',
    name: 'Recipe & Usage Tips',
    description: 'Three quick recipes and uses for $product_name in friendly recipe cards.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_stacked',
        links: ['Recipes', 'Shop', 'Tips', 'Community'],
        logoAlignment: 'center',
        backgroundColor: '#ffffff',
        linkColor: '#16a34a',
        paddingTop: 16,
        paddingBottom: 16
      }),
      hero('FRESH IDEAS INSIDE', '16a34a', 'ffffff', { paddingTop: '0', paddingBottom: '0' }),
      spacer('16'),
      heading('3 tasty ways to use $product_name', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '6'
      }),
      text('Hi $first_name, one jar, endless meals. Here are three quick and easy ideas to get the most out of your $product_name — each ready in under 20 minutes.', {
        color: '#4b5563',
        fontSize: '16',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '16'
      }),
      columns([
        [
          image('https://picsum.photos/seed/recipe1/300/200', {
            width: '100',
            alignment: 'center',
            borderRadius: '8'
          }),
          heading('Weeknight Pasta', {
            fontSize: '18',
            fontWeight: '700',
            alignment: 'center',
            color: '#16a34a',
            paddingTop: '8',
            paddingBottom: '4'
          }),
          text('Toss $product_name with hot spaghetti, a splash of olive oil, and fresh basil. Dinner in 15.', {
            color: '#4b5563',
            fontSize: '13',
            alignment: 'center',
            lineHeight: '1.6'
          })
        ],
        [
          image('https://picsum.photos/seed/recipe2/300/200', {
            width: '100',
            alignment: 'center',
            borderRadius: '8'
          }),
          heading('Loaded Toast', {
            fontSize: '18',
            fontWeight: '700',
            alignment: 'center',
            color: '#16a34a',
            paddingTop: '8',
            paddingBottom: '4'
          }),
          text('Spread $product_name on toasted sourdough, top with avocado and a pinch of chili flakes.', {
            color: '#4b5563',
            fontSize: '13',
            alignment: 'center',
            lineHeight: '1.6'
          })
        ],
        [
          image('https://picsum.photos/seed/recipe3/300/200', {
            width: '100',
            alignment: 'center',
            borderRadius: '8'
          }),
          heading('Sheet-Pan Veg', {
            fontSize: '18',
            fontWeight: '700',
            alignment: 'center',
            color: '#16a34a',
            paddingTop: '8',
            paddingBottom: '4'
          }),
          text('Drizzle $product_name over seasonal veggies and roast until golden and caramelized.', {
            color: '#4b5563',
            fontSize: '13',
            alignment: 'center',
            lineHeight: '1.6'
          })
        ]
      ]),
      spacer('20'),
      button('Get more recipes', 'https://shop.example.com/recipes', {
        backgroundColor: '#16a34a',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '32',
        buttonPaddingV: '14'
      }),
      spacer('20'),
      divider(),
      social(),
      footerBlk('Recipe ideas delivered because you love good food. <a href="{{unsubscribe}}">Unsubscribe</a>. 123 Market Street, Suite 400.', {
        backgroundColor: '#f0fdf4',
        color: '#166534',
        fontSize: '12'
      })
    ]
  },
  {
    id: 'fmcg-loyalty-sampling',
    category: 'fmcg',
    name: 'Loyalty & Sampling Invite',
    description: 'Invite members to claim a free sample and join the loyalty program.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Rewards', 'Shop', 'Recipes', 'Account'],
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#e11d48',
        paddingTop: 16,
        paddingBottom: 16
      }),
      hero('YOUR FREE SAMPLE AWAITS', 'e11d48', 'ffffff', { paddingTop: '0', paddingBottom: '0' }),
      spacer('24'),
      heading('$first_name, a treat is on us', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '8',
        paddingBottom: '8'
      }),
      text('As a thank you for being part of the family, we would love to send you a <strong>free sample of $product_name</strong>. Claim it in seconds and start earning rewards on every purchase you make.', {
        color: '#4b5563',
        fontSize: '16',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '12'
      }),
      text('You currently have <strong>$points_balance points</strong> in your rewards wallet. Join loyalty today and unlock exclusive drops, birthday perks, and members-only pricing.', {
        color: '#be123c',
        backgroundColor: '#fff1f2',
        fontSize: '15',
        alignment: 'center',
        lineHeight: '1.6',
        paddingTop: '14',
        paddingBottom: '14',
        paddingLeft: '32',
        paddingRight: '32'
      }),
      button('Claim now', 'https://shop.example.com/free-sample', {
        backgroundColor: '#e11d48',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '34',
        buttonPaddingV: '14'
      }),
      spacer('16'),
      text('Limited to one sample per household while supplies last. Delivery within 7 to 10 business days.', {
        color: '#9ca3af',
        fontSize: '12',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '40',
        paddingRight: '40'
      }),
      spacer('20'),
      divider(),
      social(),
      footerBlk('You are a valued rewards member. <a href="{{unsubscribe}}">Unsubscribe</a> from loyalty emails. 123 Market Street, Suite 400.', {
        backgroundColor: '#fff1f2',
        color: '#9f1239',
        fontSize: '12'
      })
    ]
  },
  {
    id: 'fmcg-distributor-update',
    category: 'fmcg',
    name: 'Distributor Update',
    description: 'Trade announcement with order window details in a restrained B2B tone.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        links: ['Trade Portal', 'Catalog', 'Order', 'Support'],
        logoAlignment: 'left',
        backgroundColor: '#111827',
        linkColor: '#ffffff',
        paddingTop: 16,
        paddingBottom: 16
      }),
      hero('Q3 TRADE ORDER WINDOW', '1e293b', 'ffffff', { paddingTop: '0', paddingBottom: '0' }),
      spacer('20'),
      heading('Q3 Trade Order Window Now Open', {
        fontSize: '24',
        fontWeight: '700',
        alignment: 'left',
        color: '#111827',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '8'
      }),
      text('Dear $first_name,', {
        color: '#374151',
        fontSize: '15',
        alignment: 'left',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '8'
      }),
      text('Thank you for your continued partnership. We are writing to confirm that the Q3 wholesale order window is now open. Please submit your purchase orders through the Trade Portal before the cut-off date to secure guaranteed stock allocation and priority dispatch.', {
        color: '#374151',
        fontSize: '15',
        alignment: 'left',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '12'
      }),
      text('<strong>Order window:</strong> Opens 24 July, closes 8 August.<br/><strong>Dispatch:</strong> From 18 August, pallet and case configurations unchanged.<br/><strong>New this quarter:</strong> Updated case pricing on core SKUs and the addition of $product_name to the trade catalog.', {
        color: '#374151',
        fontSize: '15',
        alignment: 'left',
        lineHeight: '1.8',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '16'
      }),
      button('Place your order', 'https://trade.example.com/orders', {
        backgroundColor: '#111827',
        textColor: '#ffffff',
        borderRadius: '6',
        fontSize: '15',
        alignment: 'left',
        buttonPaddingH: '28',
        buttonPaddingV: '13'
      }),
      spacer('16'),
      text('For allocation queries or updated trade terms, contact your account manager directly. We appreciate your business and look forward to a strong quarter together.', {
        color: '#6b7280',
        fontSize: '13',
        alignment: 'left',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32'
      }),
      spacer('20'),
      divider(),
      social(),
      footerBlk('Sent to registered trade partners. <a href="{{unsubscribe}}">Unsubscribe</a> from trade communications. 123 Market Street, Suite 400.', {
        backgroundColor: '#f3f4f6',
        color: '#6b7280',
        fontSize: '12'
      })
    ]
  },
  {
    id: 'fmcg-feedback-survey',
    category: 'fmcg',
    name: 'Feedback Survey',
    description: 'Short two-minute survey with a rewards incentive and Start survey CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_stacked',
        links: ['Shop', 'Rewards', 'Recipes', 'Contact'],
        logoAlignment: 'center',
        backgroundColor: '#ffffff',
        linkColor: '#16a34a',
        paddingTop: 16,
        paddingBottom: 16
      }),
      hero('WE WANT YOUR TAKE', '16a34a', 'ffffff', { paddingTop: '0', paddingBottom: '0' }),
      spacer('20'),
      heading('Got 2 minutes, $first_name?', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#111827',
        paddingTop: '4',
        paddingBottom: '8'
      }),
      text('Your opinion shapes what we make next. Tell us how you enjoyed <strong>$product_name</strong> in a quick 2-minute survey — just five easy questions, no login required.', {
        color: '#4b5563',
        fontSize: '16',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '32',
        paddingRight: '32',
        paddingBottom: '12'
      }),
      heading('Finish the survey and earn 200 bonus points', {
        fontSize: '18',
        fontWeight: '700',
        alignment: 'center',
        color: '#16a34a',
        backgroundColor: '#f0fdf4',
        paddingTop: '14',
        paddingBottom: '14',
        paddingLeft: '16',
        paddingRight: '16'
      }),
      spacer('16'),
      button('Start survey', 'https://shop.example.com/survey', {
        backgroundColor: '#16a34a',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '34',
        buttonPaddingV: '14'
      }),
      spacer('16'),
      text('Points land in your rewards wallet within 48 hours of completing the survey. Thank you for helping us make better products for you.', {
        color: '#9ca3af',
        fontSize: '12',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '40',
        paddingRight: '40'
      }),
      spacer('20'),
      divider(),
      social(),
      footerBlk('We only ask because we value your voice. <a href="{{unsubscribe}}">Unsubscribe</a>. 123 Market Street, Suite 400.', {
        backgroundColor: '#f0fdf4',
        color: '#166534',
        fontSize: '12'
      })
    ]
  }
]

export default TEMPLATES
